module.exports = __webpack_public_path__ + "static/img/CZ@3x.02f9ca18.jpg";